<!-- TODO: split the export and table out into separate component -->
<div class="export-file-wrapper" *ngIf="!externalIntegration">
    <form class="grid" [formGroup]="exportFormGroup">
        <div class="mb-1 col-12 md:col-3">
            <p-floatLabel variant="on">
                <p-select #ddlScheduledDate [virtualScroll]="true" itemSize="32" id="ddlScheduledDate" [filter]="true"
                    [autoDisplayFirst]="false" [options]="payPeriodDates" itemSize="16" appendTo="body"
                    baseZIndex="20001002" formControlName="scheduledDates"
                    [style]="{ 'min-width': '17rem' }"></p-select>
                <label for="ddlScheduledDate">Payroll Dates</label>
            </p-floatLabel>
        </div>
        <div class="col-12"></div>
        <div class="col-12 grid">
            <div class="mb-1 md:col-1 col-12" style="min-width: 9em">
                Payroll Codes as:
            </div>
            <div class="mb-1 col-12 md:col-1" style="min-width: 7em">
                <div class="flex items-center">
                    <p-radioButton name="payrollCodeFormat" value="col" label="Columns" #payrollCodeType
                        formControlName="payrollCodeFormat"></p-radioButton>
                    <label class="ml-2">Columns</label>
                </div>
            </div>
            <div class="mb-1 col-12 md:col-1" style="min-width: 6em">
                <div class="flex items-center">
                    <p-radioButton name="payrollCodeFormat" value="row" label="Rows" #payrollCodeType
                        formControlName="payrollCodeFormat"></p-radioButton>
                    <label class="ml-2">Rows</label>
                </div>

            </div>
            <div class="mb-1 col-12 md:col-1" style="min-width: 14em">
                <div class="flex items-center">
                    <p-radioButton name="payrollCodeFormat" value="rowreg" label="Row with REG Column" #payrollCodeType
                        formControlName="payrollCodeFormat"></p-radioButton>
                    <label class="ml-2">Row with REG Column</label>
                </div>

            </div>
        </div>
        <div class="col-12 grid p-nogutter">
            <div class="button-bar col-12 grid p-nogutter">
                <button type="button" pButton pRipple severity="primary" class="col-12 md:col-1 mr-2"
                    (click)="getPayrollExport()" pTooltip="Retrieve" label="Retrieve" icon="pi pi-angle-double-down"
                    [disabled]="!exportFormGroup.valid"></button>
                <button type="button" pButton pRipple severity="primary" icon="pi pi-download"
                    [disabled]="!items || items?.length === 0" (click)="dtPayrollExport.exportCSV()"
                    class="col-12 md:col-1" tooltipPosition="bottom" label="Export"></button>
                <!-- <button
                    type="button"
                    pButton
                    pRipple
                    icon="pi pi-upload"
                    [disabled]="!items || items?.length === 0"
                    (click)="UploadPayroll.next(ddlScheduledDate.value)"
                    class="btn btn-primary col-12 md:col-1"
                    tooltipPosition="bottom"
                    label="Upload"
                ></button> -->
            </div>
        </div>
    </form>
</div>
<div class="mb-1" *ngIf="!externalIntegration">
    <p-message [hidden]="!items || items?.length === 0" severity="info"
        text="To reorder columns, click and drag the column header"></p-message>
</div>
<div class="mb-1" *ngIf="externalIntegration">
    <button type="button" pButton pRipple icon="pi pi-download" [disabled]="!items || items?.length === 0"
        (click)="dtPayrollExport.exportCSV()" class="btn btn-secondary p-button-secondary col-12 md:col-1"
        tooltipPosition="bottom"></button>
</div>
<p-table stripedRows #dtPayrollExport [value]="items" tableStyleClass="table p-datatable-full" dataKey="id"
    [style]="{ 'min-width': '120em', width: '100%' }" scrollHeight="35vh" [scrollable]="true"
    [virtualRowHeight]="dropdownItemHeight" [columns]="cols" [reorderableColumns]="!externalIntegration">
    <ng-template pTemplate="emptymessage">
        <tr>
            <td [attr.colspan]="cols?.length" style="text-align: center">
                <div class="tabulator-placeholder">
                    <span> No Data Available </span>
                </div>
            </td>
        </tr>
    </ng-template>

    <ng-template #header>
        <tr>
            <th *ngFor="let col of cols" pReorderableColumn [ngClass]="{ unmapped: col.seq >= 99 }">
                {{ col.header }}
                <p-sortIcon [pSortableColumn]="col.field" [field]="col.field" ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
            </th>
        </tr>
    </ng-template>
    <ng-template #body let-item>
        <tr>
            <td *ngFor="let col of cols" class="p-datatable-cell" [attr.title]="item[col.field]">
                {{ item[col.field] }}
                <div style="display: none">
                    {{
                    moment(item[col.field]).isValid()
                    ? moment(item[col.field]).format('MM/DD/YYYY')
                    : item[col.field]
                    }}
                </div>
            </td>
        </tr>
    </ng-template>
</p-table>
